import { render } from "./2TypeOfCoverage.vue?vue&type=template&id=0054348a"
import script from "./2TypeOfCoverage.vue?vue&type=script&lang=js"
export * from "./2TypeOfCoverage.vue?vue&type=script&lang=js"

import "./2TypeOfCoverage.vue?vue&type=style&index=0&id=0054348a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__